import {
  Box,
  Popover,
  Text,
} from '@mantine/core'
import Link from 'next/link'
import { type PropsWithChildren } from 'react'

import {
  type CoreBundleItem,
  type CoreProduct,
} from '@flecto/types'
import { AvatarItem, TextItemQuantity } from '@flecto/ui'

import { useProductSlugEncode } from '../../hooks/useProductSlugEncode'
import { useStorePathBuilder } from '../../hooks/useStorePathBuilder'
import classes from './styles.module.css'

export type PopoverProductBundleItemsStoreParams = PropsWithChildren & {
  product: CoreProduct
}

export function PopoverProductBundleItemsStore({
  product,
  children,
  ...props
}: PopoverProductBundleItemsStoreParams) {
  if (!product?.bundle) return <>{children}</>

  return (
    <Popover position='bottom' width={330} withinPortal {...props}>
      <Popover.Target>
        <Box data-testid='popover-target'>{children}</Box>
      </Popover.Target>

      <Popover.Dropdown data-testid='popover-dropdown'>
        {product.bundle_attributes?.bundle_items?.map((bi) => (
          <RowProductItem key={bi.id} bundleItem={bi} />
        ))}
      </Popover.Dropdown>
    </Popover>
  )
}

function RowProductItem({ bundleItem }: { bundleItem: CoreBundleItem }) {
  const item = bundleItem.item

  const slug = useProductSlugEncode(item as CoreProduct)

  const path = useStorePathBuilder()

  const link = path(`/products/${slug}`)

  return (
    <Box className={classes.item}>
      <AvatarItem size='sm' item={item} className={classes.avatar} />
      <Link href={link} className={classes.title}>
        <Text fw={500} truncate>
          {item.title}
        </Text>
      </Link>
      <TextItemQuantity
        item={{ ...bundleItem.item, quantity: bundleItem.quantity }}
        withX='before'
      />
    </Box>
  )
}

